export default {
  ADD_FINANCIAL_CLUBS (state, clubs) {
    state.clubs = clubs
  },
  ADD_FINANCIAL_CLUB (state, club) {
    state.clubs = state.clubs.filter(c => !c.isNew)
    state.club = club
  },
  UPDATE_FINANCIAL_CLUB (state, club) {
    if (club.isNew === false) {
      Object.assign(state.clubs.find(c => c.id === club.id), club)
    }
    state.club = club
  },
  ADD_NEW_FINANCIAL_CLUB (state, club) {
    state.clubs = state.clubs.filter(c => !c.isNew)
    state.clubs.push(club)
    state.club = club
  },
  DELETE_FINANCIAL_CLUB (state, id) {
    state.clubs = state.clubs.filter(c => c.id !== id)
  },
  UPDATE_FINANCIAL_CLUBS (state, clubs) {
    state.clubs = clubs
  },
  ADD_SPONSOR_LOGO (state, club) {
    state.club.logos = club.logos
  },
  ADD_NEW_MEETING (state, meeting) {
    state.club.meetings.unshift(meeting)
  },
  DELETE_MEETING (state, id) {
    state.club.meetings = state.club.meetings.filter(m => m.id !== id)
  },
  UPDATE_MEETING (state, meeting) {
    Object.assign(state.club.meetings.find(m => m.id === meeting.id), meeting)
  },
  ADD_CLUB_SPEAKER (state, speaker) {
    state.club.clubSpeakers.push(speaker)
  },
  CHANGE_CLUB_SPEAKER_PHOTO (state, newSpeaker) {
    const speaker = state.club.clubSpeakers.find(s => s.id === newSpeaker.id)
    speaker.photo = newSpeaker.photo
  },
  CHANGE_CLUB_LOGO (state, logo) {
    state.club.logo = logo
  },
  DELETE_CLUB_SPEAKER (state, id) {
    state.club.clubSpeakers = state.club.clubSpeakers.filter(s => s.id !== id)
  },
  UPDATE_CLUB_SPEAKER (state, speaker) {
    Object.assign(state.club.clubSpeakers.find(s => s.id === speaker.id), speaker)
  },
  CHANGE_CLUB_ANNOUNCEMENT (state, announcement) {
    state.club.announcement = announcement
  },
  CHANGE_CLUB_PHOTOS (state, club) {
    state.club.photos = club.photos
  },
  CHANGE_CLUB_PHOTO (state, updatedClub) {
    state.club.photo = updatedClub.photo
  },
  CHANGE_CLUB_MEMBERS (state, id) {
    state.club.financialClubMembers = state.club.financialClubMembers.filter(m => m.id !== id)
  },
  DELETE_CLUB_MEETING_PARTICIPANT (state, id) {
    const meeting = state.club.meetings.find(m => m.meetingParticipants.find(p => p.id === id))
    meeting.meetingParticipants = meeting.meetingParticipants.filter(p => p.id !== id)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/financialClubs.js